<mat-card>
    <h1 class="subtitle col-md-12">{{texteService.getTexte('TITLE_DEMANDEUR')}}</h1>
    <mat-card-content class="col-md-12">
        <form [formGroup]="demandeurForm">
            <div class="form-row d-flex align-self-center">
                <label for="demandeur-nom" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_NOM')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="demandeur-nom" matInput type="text" name="nom" formControlName="nom" />
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="demandeur-prenom" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PRENOM')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="demandeur-prenom" matInput type="text" name="prenom" formControlName="prenom" />
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="demandeur-lien" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_DEMANDEUR_LIEN')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="demandeur-lien" matInput type="text" name="lien" formControlName="lien" />
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'FRA'">
                <label for="demandeur-telephone" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_TEL_PORT')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="demandeur-telephone" matInput type="tel" name="telephone" formControlName="telephone" />
                        <mat-error
                        *ngIf="demandeurForm.controls.telephone.touched && demandeurForm.controls.telephone.hasError('telUnvalid')">
                        {{texteService.getTexte('ERR_TEL_UNVALID')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="demandeur-email" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_EMAIL')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="demandeur-email" matInput type="email" name="email" formControlName="email" />
                    <mat-error
                        *ngIf="demandeurForm.controls.email.touched && demandeurForm.controls.email.hasError('email')">
                        {{texteService.getTexte('ERR_EMAIL_UNVALID')}}</mat-error>
                </mat-form-field>
            </div>
        </form>
    </mat-card-content>
</mat-card>
